<template>
<div class="ee-switch">
  <span @click="handleChange(false)" class="ee-switch__item" :class="{'is-active': value === falseValue}">{{falseText}}</span>
  <span @click="handleChange(true)" class="ee-switch__item" :class="{'is-active': value === trueValue}">{{trueText}}</span>
</div>
</template>
<script>
  export default {
    compName: 'ee-switch',
    props: {
      value: {
        default: false
      },
      trueValue: {
        default: true
      },
      trueText: {
        type: String,
        default: '是'
      },
      falseValue: {
        default: false
      },
      falseText: {
        type: String,
        default: '否'
      }
    },
    methods: {
      handleChange (state) {
        if (state) {
          this.$emit('input', this.trueValue)
        } else {
          this.$emit('input', this.falseValue)
        }
      }
    }
  }
</script>
<style>
  @component-namespace ee {
    @b switch {
      display: inline-flex;
      border: 1px solid #eee;
      @e item {
        flex: 1;
        padding: 5px 10px;
        line-height: 1;
        cursor: pointer;
        font-size: 12px;
        @when active {
          background-color: #0d60ae;
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/packages/switch/Switch.vue?37c7448e